import { Chatbox } from "@talkjs/react";
import { User } from "@shared/features/auth/auth.types";
import { Loader } from "@shared/ui/Loader";
import { Sheet } from "@shared/ui/Sheet";
import { AppPageHeader } from "@shared/ui/AppPageHeader";
import { TalkJSData } from "../../chat.types";
import { Type } from "@shared/ui/Type";

export type Props = {
  isLoading: boolean;
  isOpen: boolean;
  onClose: () => void;
  talkjsData: TalkJSData;
  user: User;
};

export function ChatSheet({
  isLoading = false,
  isOpen,
  onClose,
  talkjsData,
  user,
}: Props) {
  return (
    <Sheet
      isOpen={isOpen}
      onClose={onClose}
      className="max-w-lg overflow-auto"
      innerClassName="justify-start"
    >
      <div className="flex-1 flex flex-col p-0">
        <AppPageHeader title="Circle Chat" className="px-4 py-8 border-b" />
        {isLoading || !talkjsData || !user ? (
          <Loader isFullPage />
        ) : (
          <div className="flex flex-1 flex-col gap-4">
            {talkjsData.app_id && talkjsData.user_id && talkjsData.token ? (
              <>
                {talkjsData.conversations.map((conversationId) => (
                  <Chatbox
                    key={conversationId}
                    conversationId={conversationId}
                    loadingComponent={<Loader />}
                    style={{ width: "100%", height: "100%" }}
                  />
                ))}
              </>
            ) : (
              <div className="flex flex-col h-full gap-4 items-center justify-center">
                <Type variant="body2">No conversations found.</Type>
              </div>
            )}
          </div>
        )}
      </div>
    </Sheet>
  );
}

export default ChatSheet;
